export const BASE_CLASSNAME = 'flex flex-col rounded-xl border p-3 mb-6';

export const FOCUS_CLASSNAME = 'border-purple-200';

export const UNFOCUS_CLASSNAME = 'border-neutral-300';
